import React from 'react'
import getCollectionNameUtil from 'pages/Product/containers/Description/components/Breadcrumb/utils/get-collection-name/index.js'
import getCollectionUrlUtil from 'pages/Product/containers/Description/components/Breadcrumb/utils/get-collection-url/index.js'

const HOME = 'Home'

/**
 * @param productVariant
 * @returns {JSX.Element}
 * @constructor
 */
const ProductDescriptionPageBreadcrumb = ({
  productVariant
}) => {
  const collectionName = getCollectionNameUtil({ productVariant })
  const collectionUrl = getCollectionUrlUtil({ productVariant })

  return (
    <div>
      <nav aria-label={HOME} className='breadcrumb product-detail-breadcrumb'>
        <a className='Breadcrumbs' href='/'>{HOME} </a>
        <span className='sep'>
          <svg width='5' height='8' viewBox='0 0 5 8' fill='none' xmlns='http://www.w3.org/2000/svg'>
            <path d='M4.52 3.52006C4.61379 3.61374 4.66655 3.74083 4.66667 3.8734V4.12673C4.66513 4.25901 4.61259 4.38558 4.52 4.48006L1.09333 7.90007C1.03074 7.96317 0.945544 7.99866 0.856665 7.99866C0.767785 7.99866 0.682587 7.96317 0.619998 7.90007L0.146665 7.42673C0.0839553 7.36529 0.048617 7.28119 0.048617 7.1934C0.048617 7.10561 0.0839553 7.02151 0.146665 6.96007L3.11333 4.00006L0.146665 1.04006C0.0835604 0.977476 0.0480652 0.892277 0.0480652 0.803398C0.0480652 0.714519 0.0835604 0.62932 0.146665 0.566731L0.619998 0.100064C0.682587 0.0369601 0.767785 0.00146484 0.856665 0.00146484C0.945544 0.00146484 1.03074 0.0369601 1.09333 0.100064L4.52 3.52006Z' fill='#C2D0DE' />
          </svg>
        </span>

        <a className='Breadcrumbs' href={collectionUrl}>{collectionName}</a>

        <span className='sep'>
          <svg width='5' height='8' viewBox='0 0 5 8' fill='none' xmlns='http://www.w3.org/2000/svg'>
            <path d='M4.52 3.52006C4.61379 3.61374 4.66655 3.74083 4.66667 3.8734V4.12673C4.66513 4.25901 4.61259 4.38558 4.52 4.48006L1.09333 7.90007C1.03074 7.96317 0.945544 7.99866 0.856665 7.99866C0.767785 7.99866 0.682587 7.96317 0.619998 7.90007L0.146665 7.42673C0.0839553 7.36529 0.048617 7.28119 0.048617 7.1934C0.048617 7.10561 0.0839553 7.02151 0.146665 6.96007L3.11333 4.00006L0.146665 1.04006C0.0835604 0.977476 0.0480652 0.892277 0.0480652 0.803398C0.0480652 0.714519 0.0835604 0.62932 0.146665 0.566731L0.619998 0.100064C0.682587 0.0369601 0.767785 0.00146484 0.856665 0.00146484C0.945544 0.00146484 1.03074 0.0369601 1.09333 0.100064L4.52 3.52006Z' fill='#C2D0DE' />
          </svg>
        </span>

        <span className='breadcrumb__link' aria-current='page'>{productVariant.title}</span>
      </nav>
    </div>
  )
}

export default ProductDescriptionPageBreadcrumb
